import { computed, inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { FolderGlobalStore } from '../../../../../../store/medicalService/folder.global-store';
import { getSharingFolderIds } from '../../../../../../utils/folder.utils';
import { SERVICE_SETTINGS_CONTACTS_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import { OrganizationGlobalStore } from '../../../../../../store/organization.global-store';

@Injectable()
export class PersonContactsPageStore extends ComponentStoreV2Factory {
    public readonly folderStore = inject(FolderGlobalStore);
    public readonly orgStore = inject(OrganizationGlobalStore);

    isTerminated = this.folderStore.isTerminated;

    folderId = this.folderStore.folderId;
    folder = this.folderStore.folder;
    serviceId = this.folderStore.folder()?.serviceId || 0;
    service = this.orgStore.services().find(x => x.id === this.serviceId);
    services = this.orgStore.services();

    contactsSharingIds = computed(() => {
        return getSharingFolderIds(this.serviceId, this.services, this.folder()?.relatedFolders, SERVICE_SETTINGS_CONTACTS_TYPE_KEY);
    });
}
